import { render, staticRenderFns } from "./ValidationWorkFlows.vue?vue&type=template&id=a982659a&"
import script from "./ValidationWorkFlows.vue?vue&type=script&lang=js&"
export * from "./ValidationWorkFlows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports